import React, { useState } from "react";
// import { Link } from "react-router-dom";
import "../../index.scss";

//Panels
import Modal from "../../../Modal/Modal";

//Images
import firefeatures1 from "../../../images/categories/firefeatures/PPI-firefeature-001.jpg";
import firefeatures2 from "../../../images/categories/firefeatures/PPI-firefeature-002.jpg";
import firefeatures3 from "../../../images/categories/firefeatures/PPI-firefeature-003.jpg";
import firefeatures4 from "../../../images/categories/firefeatures/PPI-firefeature-004.jpg";
import firefeatures5 from "../../../images/categories/firefeatures/PPI-firefeature-005.jpg";
import firefeatures6 from "../../../images/categories/firefeatures/PPI-firefeature-006.jpg";
import firefeatures7 from "../../../images/categories/firefeatures/PPI-firefeature-007.jpg";
import firefeatures8 from "../../../images/categories/firefeatures/PPI-firefeature-008.jpg";
import firefeatures9 from "../../../images/categories/firefeatures/PPI-firefeature-009.jpg";
import firefeatures10 from "../../../images/categories/firefeatures/PPI-firefeature-010.jpg";
import firefeatures11 from "../../../images/categories/firefeatures/PPI-firefeature-011.jpg";
import firefeatures12 from "../../../images/categories/firefeatures/PPI-firefeature-012.jpg";
import firefeatures13 from "../../../images/categories/firefeatures/PPI-firefeature-013.jpg";
import firefeatures14 from "../../../images/categories/firefeatures/PPI-firefeature-014.jpg";
import firefeatures15 from "../../../images/categories/firefeatures/PPI-firefeature-015.jpg";
import firefeatures16 from "../../../images/categories/firefeatures/PPI-firefeature-016.jpg";
import firefeatures17 from "../../../images/categories/firefeatures/PPI-firefeature-017.jpg";
import firefeatures18 from "../../../images/categories/firefeatures/PPI-firefeature-018.jpg";
import firefeatures19 from "../../../images/categories/firefeatures/PPI-firefeature-019.jpg";
import firefeatures20 from "../../../images/categories/firefeatures/PPI-firefeature-020.jpg";
import firefeatures21 from "../../../images/categories/firefeatures/PPI-firefeature-021.jpg";
import firefeatures22 from "../../../images/categories/firefeatures/PPI-firefeature-022.jpg";

//Utils
import { mapGallery } from "../../../../../Utils/Utils";

// SEO
// import SEO from "../../../../../SEO/index.js";

const FireFeatures = () => {
  const [showModal, setShowModal] = useState(false);
  const [current, setCurrent] = useState(0);

  const images = [
    firefeatures1,
    firefeatures2,
    firefeatures3,
    firefeatures4,
    firefeatures5,
    firefeatures6,
    firefeatures7,
    firefeatures8,
    firefeatures9,
    firefeatures10,
    firefeatures11,
    firefeatures12,
    firefeatures13,
    firefeatures14,
    firefeatures15,
    firefeatures16,
    firefeatures17,
    firefeatures18,
    firefeatures19,
    firefeatures20,
    firefeatures21,
    firefeatures22,
  ];

  return (
    <>
      {/* <SEO
        title="Los Angeles Fire Pits & Fireplaces Examples | Fire Features Gallery"
        description="See our amazing collection of fire features installed all over Los Angeles & Southern California.  We can create any style you're looking for."
        profileURL={
          "https://www.pacificoutdoorliving.com/gallery/firefeatures/"
        }
        type="website"
      /> */}
      <div className="container-fluid no-side-padding gallery-wrapper">
        {/* <div className="row justify-content-center hero-unit">
          <div className="col-12 no-side-padding">
            <div className="title">
              <Link to="/gallery">Back to Gallery</Link>
              <h1>Fire Features Gallery</h1>
            </div>
          </div>
        </div> */}
        <div className="row justify-content-center">
          <div className="col-11">
            <div className="row gallery-images">
              {mapGallery(images, "firefeatures", setShowModal, setCurrent)}
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          items={images}
          current={current}
        />
      </div>
    </>
  );
};

export default FireFeatures;
